import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=76a51fa0&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=ts"
export * from "./OrderConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a51fa0",
  null
  
)

export default component.exports